import React from 'react'
import './style.scss'

export const SpotifyArtistCard = (props) => {
  const {
    nombre,
    foto,
    link
  } = props

  return (
    // Aún no hay ruta de artistas
    <a href={link}>
        <div className="text-center">
            <img src={foto} className="profile-card" />
            <p className="pt-3">{nombre}</p>
        </div>
    </a>
  )
}
